// this file sets the top margin on <main> if there's a sticky header
const $ = require('jquery');
const { $window } = require('../lib/selectors');
const { menuBreakpoint } = require('../lib/widths');

const $stickyHeader = $('.site-header.sticky');
const $mainSection = $('main.main-content');

let stuck = false;
let headerHeight;
let belowBreakpoint = false;

// add event listeners if menu is sticky
if ($stickyHeader.length) {
  console.log('has sticky');
  stickMenuCheck(); // fire immediately
  document.addEventListener('scroll', stickMenuCheck, {
    passive: true,
  });
  document.addEventListener('scroll', stickMenuCheck);

  window.addEventListener('resize', stickMenuCheck, {
    passive: true,
  });
}

function stickMenuCheck() {
  console.log('in check');
  const offset = $('header .main-menu')[0].offsetTop;
  headerHeight = $stickyHeader.outerHeight();
  // if menu if sticky and over content, there doesn't need to be an offset
  if ($stickyHeader.hasClass('site-header--absolute')) {
    headerHeight = 0;
  }
  const scrolledOffset = $(document).scrollTop();
  if (window.innerWidth >= menuBreakpoint) {
    // unset margin if coming from below breakpoint to above
    if (belowBreakpoint) {
      $mainSection.css('margin-top', '');
    }
    belowBreakpoint = false;

    // check if we need to stick or unstick menu
    if (scrolledOffset > offset && !stuck) {
      // stick it
      stickMenu(offset);
    } else if (scrolledOffset < offset && stuck) {
      // unstick it
      unstickMenu();
    }
  } else {
    // when under menu breakpoint
    if (stuck) {
      unstickMenu();
      stuck = false;
    }

    belowBreakpoint = true;
    $mainSection.css('margin-top', headerHeight);
  }
}

function stickMenu(offset) {
  stuck = true;
  $stickyHeader.addClass('stuck');
  $stickyHeader.css('top', `-${offset + 1}px`);
  $mainSection.css('margin-top', headerHeight);
}

function unstickMenu() {
  $stickyHeader.removeClass('stuck');
  $stickyHeader.css('top', '');
  $mainSection.css('margin-top', '');
  stuck = false;
}




// ************************ //
// Handle the animating Search Bar in Top Green Bar on mobile views.
const $searchBar = $('.green-bar-right .form-item');
const $searchForm = $('#views-exposed-form-search-page-1');
const $searchIcon = $('.green-bar-right .form-actions');
const $closeIcon = $('.green-bar-right .icon-close');
let searchBool = false; // a quick boolen check to see if search bar is expanded or not
let closeIconVisible = false;

// setup the 'open' function
function openSearchBar() {
  if (window.innerWidth < menuBreakpoint && !closeIconVisible) {
    $('.green-bar__left').delay(0).fadeOut(0);
    $('.green-bar-right nav').delay(0).fadeOut(0);
    $('.green-bar-right').prepend('<span class="icon-close"></span>');
    $('#block-exposedformsearchpage-1').css({ 'width': '100%' });
    $('.green-bar__right').css({ 'width': '100%' });
    $searchBar.css({ 'visibility': 'visible', 'max-width': '100%' });
    $searchIcon.off();
  }
}

// setup the 'close' function
function closeSearchBar() {
  //if (window.innerWidth < menuBreakpoint && searchBool) {
    $searchBar.removeAttr('style');
    $('.green-bar__right').removeAttr('width');
    $('#block-exposedformsearchpage-1').removeAttr('style');
    $('.green-bar-right span.icon-close').remove();
    $('.green-bar-right nav').delay(300).fadeIn(250);
    $('.green-bar__left').delay(300).fadeIn(250);
    searchBool = false; // reset the boolen
    closeIconVisible = false;
    iconsFunctions(); // re-run and reset the icons clicking capabilities
  //}
}

// run the icons function immediately on page load
iconsFunctions();

// function to control the clicking of the search glass and close icons.
function iconsFunctions() {

  if (window.innerWidth < menuBreakpoint) {

    $searchIcon.on('click', function(e) {
      e.preventDefault();
      openSearchBar();
      searchBool = !searchBool;
      closeIconVisible = true;
    });

    $('.green-bar-right').on('click', '.icon-close', function(e) {
      e.preventDefault();
      closeSearchBar();
    });

  }

}

// run the functions again as window is being resized
$(window).on('resize', function() {

  // close the search bar if it is open and window gets resized bigger than 800px breakpoint
  if (window.innerWidth > 1000 && searchBool) {
    closeSearchBar();
  }

});

